module.exports = __webpack_public_path__ + "static/og-fb2b1ef8d54b0f814cce1cd7a5cdf10a.jpg";